<template>
	<div class="px-4 pb-12 d-flex flex-column align-center justify-center" style="max-height: 600px">
		<h1 class="mt-12 text-center error--text" style="font-weight: 900;">
			{{ title }}
		</h1>
		<h4 class="text-center error--text my-5" style="max-width: 500px">
			{{ subtitle }}
		</h4>
		<base-button
			@click="routerReplace($route, $router, { name: ROUTER.RUNNITS_HOME })"
			class="my-3"
			call-to-action
			large
		>
			Go to Home
		</base-button>
	</div>
</template>

<script>
import Vue from 'vue';
import { ROUTER } from '@/router/constants';

export default Vue.extend({
	name: 'Page404',
	metaInfo: {
		title: 'Page Not Found | RunDiffusion',
	},
	props: {
		title: { type: String, default: '404' },
		subtitle: { type: String, default: 'This page was not found, please check the URL' },
	},
	data () {
		return {
			ROUTER,
		};
	},
});
</script>
